// One native PostHog identity for the loaded app. Rejecting optional persistence
// keeps the memory identity; acceptance saves it. No server hash, aliases or replay.
export function trackingConfig(status) {
  return {
    persistence: status === "granted" ? "localStorage+cookie" : "memory",
    cookieless_mode: undefined,
    opt_out_capturing_by_default: false,
    cross_subdomain_cookie: false,
    cookieWinsOnConflict: true,
    capture_pageview: false,
  };
}

export function createAnalyticsTracking(client, initialStatus) {
  let status = initialStatus;
  let changing = false;

  return {
    get status() {
      return status;
    },
    get changing() {
      return changing;
    },
    get mode() {
      return status === "granted" ? "persistent" : "memory";
    },
    setConsent(nextStatus) {
      if (nextStatus === status) return;
      changing = true;
      try {
        if (status === "granted" && nextStatus !== "granted") {
          // Withdrawal must not keep using a previously persistent identity.
          // Remove durable storage before reset so a replacement is never saved.
          client.set_config({ persistence: "memory", disable_persistence: true });
          client.reset(true);
        }
        // Ordinary rejection preserves both the pending ID and its current session.
        // These choices govern persistence, so do not use SDK opt_out_capturing():
        // that would also stop the in-memory measurement selected by the app.
        client.set_config({ ...trackingConfig(nextStatus), disable_persistence: false });
        status = nextStatus;
      } finally {
        changing = false;
      }
    },
  };
}
